import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { TemplateIcon } from 'components/Atoms/Icon';

const TemplateManagement = lazy(() => import('components/Pages/Template/List'));
const CreateTemplate = lazy(() => import('components/Pages/Template/Create'));
const ViewReport = lazy(() => import('components/Pages/Template/Report'));

export const templateRoutes = [
  {
    path: routePath.TEMPLATE,
    component: TemplateManagement,
    name: routeName.TEMPLATE,
    showMenu: true,
    icon: TemplateIcon,
    exact: true,
    breadcrumbs: [{ name: routeName.TEMPLATE }],
  },
  {
    path: routePath.CREATE_TEMPLATE,
    component: CreateTemplate,
    name: routeName.CREATE_TEMPLATE,
    showMenu: false,
    icon: TemplateIcon,
  },
  {
    path: routePath.VIEW_REPORT,
    component: ViewReport,
    name: routeName.VIEW_REPORT,
    showMenu: false,
    icon: TemplateIcon,
  },
];
